import { render } from "./form-topic.vue?vue&type=template&id=42380b6d&ts=true"
import script from "./form-topic.vue?vue&type=script&lang=ts"
export * from "./form-topic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__